export default __webpack_public_path__ + "60182f3fb9ae9391c383ea7862b565b3.svg";